<template>
  <div style="margin: 2em 2em 0.5em 2em;">
    <div class="box">
      <BInputText
        label-text="手机号"
        :required="true"
        v-model="accountInfo.account"
        :maxLength="11"
        placeholder="请输入手机号"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="密码"
        :required="true"
        v-model="accountInfo.password"
        :maxLength="20"
        type="password"
        placeholder="请输入密码"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="确认密码"
        :required="true"
        v-model="accountInfo.rpassword"
        :maxLength="20"
        type="password"
        placeholder="请确认密码"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="姓名"
        :required="true"
        v-model="accountInfo.userName"
        :maxLength="20"
        placeholder="请输入姓名"
      />
    </div>
    <div class="box">
      <BInputText
        label-text="身份证号"
        :required="true"
        v-model="accountInfo.idCardNum"
        :maxLength="18"
        placeholder="请输入身份证号"
        @changed="idCardNumCheck"
      />
    </div>
    <div class="box">
      <BInputPullDown
        label-name="性别"
        v-model="accountInfo.sex"
        :Options="sexList"
        :disabled="editFlag"
      />
    </div>
    <div class="box">
      <BBtnRadio
        label-text="角色"
        v-model="roleList"
        @input="clickRadio"
        style="margin: 12px 0;"
      />
    </div>
    <div class="box" style="margin: 12px 0;" v-show="checkroleid">
      <label style="margin: 0px 10px 0 20px;width: 60px;font-size: 14px;color: #333333;text-align: right;">权限范围</label>
      <BBtnCheckbox
        id="menu"
        label-text="全部"
        :value="checkedall"
        :booleanValue="checkedall"
        @changed="checkAll"
      />
    </div>
    <div class="box" v-show="checkroleid">
      <label style="margin: 0px 10px 0 20px;width: 60px;font-size: 14px;color: #333333;text-align: right;"></label>
      <div style="display: flex;flex-wrap: wrap;max-width: 400px;">
        <div v-for="classs in classList" :key="classs.value">
          <BBtnCheckbox
            :id="classs.id"
            :label-text="classs.itemlabel"
            :value="classs.booleanValue"
            :booleanValue="classs.booleanValue"
            @changed="checkChanged(classs.value)"
            style="margin: 15px 0;"
          />
        </div>
      </div>
    </div>
    <div class="box">
      <BBtnPrimary
        v-if="userId == 0"
        :clicked="doSave"
        btn-txt="添加"/>
      <BBtnPrimary
        v-else
        :clicked="doUpdate"
        btn-txt="编辑"/>
      <BBtnPrimary
        :clicked="doBack"
        btn-txt="返回"/>
    </div>
  </div>
</template>
<script>
import { add,detail,updata } from '@/api/account'
import BInputText from "../../components2/BInputText";
import BInputPullDown from "../../components2/BInputPullDown";
import BBtnRadio from "../../components2/BBtnRadio";
import BBtnCheckbox from "../../components2/BBtnCheckbox";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Vue from "vue";
  export default {
    components: {
      BInputText,
      BInputPullDown,
      BBtnRadio,
      BBtnCheckbox,
      BBtnPrimary,
    },
    props:{
      editflg: Boolean,
      id: Number,
    },
    data(){
      return {
        accountInfo: {
          id:0,
          account: '',
          password: '',
          userName:'',
          rpassword:'',
          roleId:0,
          classIdList:[],
          sex:'',
          idCardNum:'',
        },
        checkedall:false,
        userId:"",
        checkroleid:false,
        messageText: "",
        roleList: {
          checked: '',
          data: [],
        },
        checked: [],
        sexList: [],
        classList: [],
        editFlag:true,
        routerflg:'',
      };
    },
    created() {
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(
                Object.assign(
                    {},
                    this.$store.state,
                    JSON.parse(sessionStorage.getItem("store"))
                )
            );
            sessionStorage.removeItem("store");
        }
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state));
        });
    },
    // 页面载入之前
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (vm.$route.params.editflg) {
        vm.userId = vm.$route.params.id;
        vm.routerflg = true;
        }
        const params = {
            userId: vm.$route.params.id,
            routerflg: vm.routerflg,
        };
        console.log(params)
        if (
            params.userId !== null &&
            params.userId !== "" &&
            params.userId !== undefined &&
            params.routerflg !== null &&
            params.routerflg !== "" &&
            params.routerflg !== undefined
        ) {
            // 把不为空的参数存入缓存
            vm.$store.commit("SET_ACCOUNT_DETAIL_PARAMS", params);
            console.log(params)
        }
        // 参数赋值
        if (
            vm.$store.state.account_userId !== undefined &&
            vm.$store.state.account_userId !== null &&
            vm.$store.state.account_userId !== "" && 
            vm.$store.state.account_routerflg !== undefined &&
            vm.$store.state.account_routerflg !== null &&
            vm.$store.state.account_routerflg !== ""
        ) {
            vm.userId = vm.$store.state.account_userId;
            vm.routerflg = vm.$store.state.account_routerflg;
        }
        console.log(vm.userId, vm.routerflg)
      })
    },
    mounted () {
      console.log(this.id)
      if (this.id) {
        this.userId = this.id;
      }
        this.init()

    },
    methods: {
       // 初始化
      async init () {
        var param = {
          id:this.userId
          }
        const data = await detail(param)
        this.accountInfo.userName = data.data.userName
        this.accountInfo.password = data.data.password
        this.accountInfo.rpassword = data.data.password
        this.accountInfo.account = data.data.account
        this.accountInfo.roleId = data.data.roleId
        this.accountInfo.idCardNum = data.data.idCardNum       
        this.accountInfo.sex = data.data.sex
        this.sexList = data.data.sexList

        let roleDataList = data.data.roleList
        let len = roleDataList.length
        let roleDatas = []
        let checkIndex = ""
        for (let i = 0; i < len; i++) {
          let roleData = {
            id: 'roleRadio' + roleDataList[i].value,
            name: 'roleRadio',
            label: roleDataList[i].text,
            value: roleDataList[i].value,
          }
          roleDatas.push(roleData)
          if (this.accountInfo.roleId === null && roleDataList[i].text == '班主任') {
            checkIndex = roleDataList[i].value
          }
        }
        if (this.accountInfo.roleId !== null) {
          this.roleList.checked = this.accountInfo.roleId
        } else {
          this.roleList.checked = checkIndex
        }
        this.roleList.data = roleDatas

        // check角色
        if (this.accountInfo.roleId === null) {
          this.accountInfo.roleId = checkIndex
        }
        if(this.accountInfo.roleId == null || this.accountInfo.roleId == this.roleList.data[0].value ){
          this.checkroleid = false
        }else{
          this.checkroleid = true 
        } 
        // 权限范围check
        let classDataList = []
        for (let i = 0; i < data.data.classList.length; i++) {
          let classData = {
            id: 'class' + data.data.classList[i].value,
            value: data.data.classList[i].value,
            itemlabel: data.data.classList[i].text,
            booleanValue: false
          }
          if (data.data.classIdList != null && data.data.classIdList.length > 0) {
            let classLen = data.data.classIdList.length
            for (let j = 0; j < classLen; j++) {
              if (String(data.data.classList[i].value) === String(data.data.classIdList[j])) {
                classData.booleanValue = true
                this.accountInfo.classIdList.push(data.data.classList[i].value)
                break;
              }
            }
          } else {
            classData.booleanValue = false
          }
          classDataList.push(classData)
        }
        this.classList = classDataList

        // checkBox全部勾选
        if (this.accountInfo.classIdList.length === this.classList.length) {
          this.checkedall = true
        }
      },
      // 全部
      checkAll(e){
        if(e){
          var selectArry = []
          for(var i = 0; i < this.classList.length; i++){
             this.classList[i].booleanValue = true
             selectArry.push(this.classList[i].value)
          }
          this.accountInfo.classIdList = selectArry
        }else{
          this.accountInfo.classIdList = []
          for(var j = 0; j < this.classList.length; j++){
            this.classList[j].booleanValue = false
          }
        }
      },
      // 班级勾选
      checkChanged(value){
        let index = -1
        if (this.accountInfo.classIdList != null && this.accountInfo.classIdList.length > 0) {
          let len = this.accountInfo.classIdList.length
          for (let i = 0; i < len; i++) {
            if (this.accountInfo.classIdList[i] === value) {
              index = i
            }
          }
        }

        if (index > -1) {
          this.accountInfo.classIdList.splice(index, 1)
        } else {
          this.accountInfo.classIdList.push(value)
        }

        // checkBox全部勾选
        if (this.accountInfo.classIdList.length === this.classList.length) {
          this.checkedall = true
        } else { 
          this.checkedall = false
        }
      
      },
      // 角色
      clickRadio(data){
        this.accountInfo.roleId = data.checked
        // check角色
        if(this.accountInfo.roleId == this.roleList.data[0].value){
            this.checkroleid = false
        }else{
            this.checkroleid = true
        }
      },
      // 返回
      doBack () {
        if (this.routerflg) {
        this.$router.push({
          name: "teach-team-detail",
          params: {
            userId: this.userId,
          },
        });
      }
        var obj = {
        flag: 1,
      }
      this.$emit('openFlag',obj)
      },
      //添加
      async doSave () {
        this.doItemCheck()
        if (this.messageText !== '') {
          Vue.prototype.$valertbar.show(this.messageText);
          return
        }
        const data = await add(this.accountInfo)
        if (data.code === 0) {
          Vue.prototype.$vsnackbar.show(data.msg);
          this.doBack()
        } else {
          Vue.prototype.$valertbar.show(data.msg);
        }
      },
      //更新
      async doUpdate () {
        this.doItemCheck()
        if (this.messageText !== '') {
          Vue.prototype.$valertbar.show(this.messageText);
          return
        }
        this.accountInfo.id=this.userId;
        const data = await updata(this.accountInfo)
        if (data.code === 0) {
          Vue.prototype.$vsnackbar.show(data.msg);
          this.doBack()
        } else {
          Vue.prototype.$valertbar.show(data.msg);
        }
      },
      // 项目验证
      doItemCheck () {
        // 验证
        this.messageText = ''
        if (this.accountInfo.account === null || this.accountInfo.account === '') {
          this.messageText = '手机号必须输入！'
          return false
        }
        if (!this.comUtils.checkTelNo(this.accountInfo.account)) {
          this.messageText = '输入的手机号有错,请重新输入！'
          return false
        }
        // 密码
        if (this.accountInfo.password === null || this.accountInfo.password === '') {
          this.messageText = '密码必须输入！'
          return false
        }
        if (this.accountInfo.password.length>20) {
          this.messageText = '输入的密码长度不能超过20位！'
          return false
        }
        if (this.accountInfo.rpassword === null || this.accountInfo.rpassword === '') {
          this.messageText = '密码必须输入！'
          return false
        }
        // 在输入密码
        if (this.accountInfo.rpassword.length>20) {
          this.messageText = '输入的密码长度不能超过20位！'
          return false
        }
        if (this.accountInfo.password !==  this.accountInfo.rpassword) {
          this.messageText = '密码不一致！'
          return false
        }
         // 姓名验证
        if (this.accountInfo.userName === null || this.accountInfo.userName === '') {
          this.messageText = '姓名必须输入！'
          return false
        }
        if (this.accountInfo.userName.length > 20) {
          this.messageText = '输入的姓名长度不能超过20位！'
          return 
        }
        // 角色验证
        if (this.accountInfo.roleId === null || this.accountInfo.roleId === '') {
          this.messageText = '角色必须选择！'
          return false
        }
        // 身份证号码验证
        this.idCardNumCheck(this.accountInfo.idCardNum)
        this.accountInfo.userName = this.comUtils.trim(this.accountInfo.userName)
      },
      
      // 身份证号验证
      idCardNumCheck (idCardNum) {
        this.accountInfo.sex = ''
        if (!this.comUtils.checkIdCardNo(idCardNum)) {
          this.messageText = '身份证号码有误！'
          return false
        }
        // 性别
        this.accountInfo.sex = this.comUtils.getSexByIdCardNo(idCardNum)
        return true
      },
    },
  }
</script>

<style lang="scss" scoped>
  span.xrequired::after {
        content: '* ';
        color: red;
  }
  span.column::after {
        content: '丨';
        font-weight: bold;
        color: rgb(0, 162, 255);
  }
  .search{
    max-width: 30%;
  }
  .date-pick{
    max-width: 20%;
  }
  .v-btn.v-size--default {
    font-size: 15px;
  }
  .v-btn.v-size--small {
    font-size: 12px;
  }
  ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 16px;
    font-weight: bold;
    color: black;
  }
  ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    display: none;
  }
  ::v-deep .theme--light.v-data-table{
    color: black;
  }
  ::v-deep .v-data-footer{
    font-size: 14px;
    color: black;
  }
  .tooltip {
    background-color: #FFFFFF;
    color: #000000;
    opacity:1 !important;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
    padding:0 12px;
  }
::v-deep .v-card--material__heading {
  padding: 15px 0 !important;
  width: 125px !important;
}

::v-deep .v-chip .v-chip__content {
  font-size: 16px;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
::v-deep .v-card .v-card--material__heading {
  max-width: 10%;
  min-width: 90px;
  height: 56px;
  padding: 15px 0 !important;
  background-color:  #33CCFF !important;
  border-color:  #33CCFF !important;
}
.dialog-showSignLog {
  background-color: #ffffff;
  color: #000000;
  opacity: 1 !important;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  padding: 0 12px;
}
.shooting-tips-font {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #929292;
  line-height: 32px;
  text-align: center;
}
.right-zero {
  padding-right: 0px;
}
.left-zero {
  padding-left: 0px;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
